import React from 'react';

const styles = {
  page: { fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '40px 20px', color: '#333', lineHeight: '1.8' },
  title: { fontSize: '28px', fontWeight: '700', marginBottom: '4px' },
  company: { fontSize: '16px', fontWeight: '600', color: '#555', marginBottom: '8px' },
  updated: { color: '#888', marginBottom: '32px', fontSize: '14px' },
  heading: { fontSize: '18px', fontWeight: '700', marginBottom: '8px', marginTop: '32px' },
  paragraph: { marginBottom: '12px' },
  list: { paddingLeft: '20px', marginTop: '8px', marginBottom: '12px' },
};

// Section content blocks: a string renders as a paragraph, an array as a
// bullet list, and { lines: [...] } as a single paragraph with line breaks.
const renderBlock = (block, index) => {
  if (Array.isArray(block)) {
    return (
      <ul key={index} style={styles.list}>
        {block.map((item) => <li key={item}>{item}</li>)}
      </ul>
    );
  }
  if (block.lines) {
    return (
      <p key={index} style={styles.paragraph}>
        {block.lines.map((line, i) => (
          <React.Fragment key={line}>
            {i > 0 && <br />}
            {line}
          </React.Fragment>
        ))}
      </p>
    );
  }
  return <p key={index} style={styles.paragraph}>{block}</p>;
};

const LegalDocument = ({ title, lastUpdated, intro, sections }) => (
  <div style={styles.page}>
    <h1 style={styles.title}>{title}</h1>
    <p style={styles.company}>Perfect Layout Private Limited</p>
    <p style={styles.updated}>Last updated: {lastUpdated}</p>
    <p style={styles.paragraph}>{intro}</p>
    {sections.map((section) => (
      <section key={section.heading}>
        <h2 style={styles.heading}>{section.heading}</h2>
        {section.content.map(renderBlock)}
      </section>
    ))}
  </div>
);

export default LegalDocument;
